import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { ActionStatus } from "../../api-services/ai-chat";
import {
  ACTION_STATUS,
  ACTION_STATUS_COLORS,
  UI_CONSTANTS,
} from "../../commons/ai-chat.constants";

interface PlanActionItemProps {
  action: {
    id: string;
    description: string;
    parameters?: Record<string, any>;
  };
  status: ActionStatus;
}

const PlanActionItem = ({ action, status }: PlanActionItemProps) => {
  const renderIcon = () => {
    switch (status) {
      case ACTION_STATUS.PENDING:
        return (
          <RadioButtonUncheckedIcon
            sx={{
              fontSize: UI_CONSTANTS.ICON_SIZE,
              color: ACTION_STATUS_COLORS.PENDING,
            }}
          />
        );
      case ACTION_STATUS.EXECUTING:
        return (
          <CircularProgress
            size={UI_CONSTANTS.ICON_SIZE}
            sx={{ color: ACTION_STATUS_COLORS.EXECUTING }}
          />
        );
      case ACTION_STATUS.COMPLETED:
        return (
          <CheckCircleIcon
            sx={{
              fontSize: UI_CONSTANTS.ICON_SIZE,
              color: ACTION_STATUS_COLORS.COMPLETED,
            }}
          />
        );
      case ACTION_STATUS.FAILED:
        return (
          <ErrorIcon
            sx={{
              fontSize: UI_CONSTANTS.ICON_SIZE,
              color: ACTION_STATUS_COLORS.FAILED,
            }}
          />
        );
      default:
        return (
          <RadioButtonUncheckedIcon
            sx={{
              fontSize: UI_CONSTANTS.ICON_SIZE,
              color: ACTION_STATUS_COLORS.PENDING,
            }}
          />
        );
    }
  };

  const getTextColor = () => {
    if (status === ACTION_STATUS.FAILED) {
      return ACTION_STATUS_COLORS.FAILED;
    }
    if (status === ACTION_STATUS.COMPLETED) {
      return ACTION_STATUS_COLORS.COMPLETED;
    }
    return ACTION_STATUS_COLORS.TEXT_DEFAULT;
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
        {renderIcon()}
      </Box>
      <Typography
        variant="caption"
        sx={{
          fontSize: UI_CONSTANTS.FONT_SIZE_SMALL,
          color: getTextColor(),
        }}
      >
        {action.description}
      </Typography>
    </Box>
  );
};

export default PlanActionItem;
